import { createSelector } from 'reselect'

import {
  CartStatus,
  getCart,
} from '~shared-components/redux/reducers/cart.reducers'
import { SharedState } from '~shared-components/redux/sharedState'
import { ifArrayReturnNthItem } from '~shared-components/utils/functional'

import { LocationSelector } from './location.selector'

export const selectCartState = (state: SharedState) => state && state.cart
export const selectLoginState = (state: SharedState) => state && state.login

const isPopulated = createSelector([selectCartState], state => state?.populated)

const cart = createSelector(
  [selectCartState, selectLoginState],
  (cartState, loginState) =>
    getCart(
      loginState?.selectedCustomerContext?.customerContextId,
      cartState.carts,
    ),
)

export const products = createSelector(
  [selectCartState, selectLoginState],
  (cartState, loginState) => {
    const cart = getCart(
      loginState?.selectedCustomerContext?.customerContextId,
      cartState.carts,
    )
    return cart?.products ?? []
  },
)

const orderConfirmation = createSelector(
  [selectCartState, LocationSelector.location],
  (state, location) => state.orderConfirmations[location.payload.id],
)

const hasProductsInCart = createSelector(
  products,
  products => products.length !== 0,
)

const cartStatus = createSelector([selectCartState], state => state?.cartStatus)

const isValidated = createSelector(
  [selectCartState],
  state =>
    state?.cartStatus === CartStatus.VALID ||
    state?.cartStatus === CartStatus.INVALID,
)

const isLoading = createSelector([selectCartState], state => state?.loading)

const currency = createSelector(
  cart,
  cart =>
    cart?.products && ifArrayReturnNthItem(cart.products)?.price?.getCurrency(),
)

const shipToLocation = createSelector(cart, cart => cart?.shipToLocation)

export const CartSelector = {
  cart,
  cartState: selectCartState,
  cartStatus,
  currency,
  hasProductsInCart,
  isLoading,
  isPopulated,
  isValidated,
  orderConfirmation,
  products,
  shipToLocation,
}
